import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { FilterProps } from "../../types/AppTypes";

export interface InitialStateProps {
  searchCareerManagers: string;
  filtersCareerManagers: FilterProps[];
  paginationCareerManagers: number;
}

export const initialState: InitialStateProps = {
  searchCareerManagers: "",
  filtersCareerManagers: [],
  paginationCareerManagers: 0,
};

export const careerManagerSlice = createSlice({
  name: "careerManagers",
  initialState,
  reducers: {
    setSearchCareerManagers: (
      state: InitialStateProps,
      action: PayloadAction<string>,
    ) => {
      state.searchCareerManagers = action.payload;
    },
    setFiltersCareerManagers: (
      state: InitialStateProps,
      action: PayloadAction<FilterProps[]>,
    ) => {
      state.filtersCareerManagers = action.payload;
    },
    setPaginationCareerManagers: (
      state: InitialStateProps,
      action: PayloadAction<number>,
    ) => {
      state.paginationCareerManagers = action.payload;
    },
    resetCareerManagersState: () => initialState,
  },
});

export const {
  setSearchCareerManagers,
  setFiltersCareerManagers,
  setPaginationCareerManagers,
  resetCareerManagersState,
} = careerManagerSlice.actions;
export default careerManagerSlice.reducer;
